class VideoSection extends HTMLElement {
  constructor() {
    super();
    this.videoType = this.dataset.videoType;
    this.currentStatus = "play";
  }

  connectedCallback() {
    if (this.videoType === 'shopify') {
      this.initShopifyVideo();
    } else if (this.videoType === 'youtube') {
      this.initYouTubeVideo();
    }
  }

  initShopifyVideo() {
    this.playButton = this.querySelector("[data-video-button]");
    this.videoPlaceholder = this.querySelector("[data-video-placeholder]");
    this.playIcon = this.querySelector("[data-video-button-play]");
    this.pauseIcon = this.querySelector("[data-video-button-pause]");
    this.videoTemplate = this.querySelector("[data-video-template]");

    if (!this.playButton || !this.videoTemplate) return;

    this.playButton.addEventListener("click", () => {
      if (!this.videoInserted) {
        this.insertVideo();
      }
      this.togglePlayPause();
    });
  }

  insertVideo() {
    if (!this.videoTemplate || !this.videoPlaceholder) return;

    const videoElement = this.videoTemplate.content.firstElementChild.cloneNode(true);
    this.videoPlaceholder.innerHTML = '';
    this.videoPlaceholder.appendChild(videoElement);

    this.video = this.querySelector("[data-video]");
    this.videoInserted = true;

    if (this.video) {
      this.video.addEventListener("click", () => {
        this.togglePlayPause();
      });
    }
  }

  togglePlayPause() {
    if (!this.video) return;

    if (this.currentStatus === "play") {
      this.currentStatus = "pause";
      this.playButton.classList.add("playing");
      this.video.play();
    } else {
      this.currentStatus = "play";
      this.playButton.classList.remove("playing");
      this.video.pause();
    }
  }

  initYouTubeVideo() {
    const iframe = this.querySelector('iframe');
    if (!iframe) return;

    // YouTube iframe API integration can be added here if needed
    // For now, YouTube videos will use default YouTube player controls
  }

  disconnectedCallback() {
    if (this.video) {
      this.video.pause();
    }
  }
}

customElements.define('video-section', VideoSection);

